import * as React from "react";
export interface SwitchProps<ValueType = any> {
    settingLabel?: string,
    leftLabel: string,
    rightLabel: string,
    leftValue: ValueType,
    rightValue: ValueType,
    value: ValueType,
    onChange?: (event: React.MouseEvent | React.KeyboardEvent, newValue: ValueType) => void,
}

export function Switch<ValueType = any>(props: SwitchProps<ValueType>): React.ReactElement {
    const selectedClass = "Switch-button Switch-selected";
    const unselectedClass = "Switch-button";
    return (
        <button
            className="Switch-outer"
            aria-label={props.settingLabel}
            onClick={(e) => {
                const inverted = props.value === props.rightValue ? props.leftValue : props.rightValue;
                e.preventDefault();
                props.onChange?.(e, inverted);
            }}
        >
            <label className={props.value === props.leftValue ? selectedClass : unselectedClass}>{props.leftLabel}</label>
            <label className={props.value === props.rightValue ? selectedClass : unselectedClass}>{props.rightLabel}</label>
        </button>
    );
}